import { render, staticRenderFns } from "./editRecoil.vue?vue&type=template&id=0cec2b19&scoped=true"
import script from "./editRecoil.vue?vue&type=script&lang=js"
export * from "./editRecoil.vue?vue&type=script&lang=js"
import style0 from "./editRecoil.vue?vue&type=style&index=0&id=0cec2b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec2b19",
  null
  
)

export default component.exports